import React from "react";
import Font from "../components/Font/Font";

export default class SlaveStyles extends React.PureComponent {
  render() {
    const { primaryColor, customCSS = "", fonts, design, slideBackgroundImage } = this.props;

    // console.log("primaryColor", primaryColor);
    // console.log("customCSS", customCSS);
    // console.log("design", design);

    const slideDesign = design?.slide || {};
    const chevronColor = slideDesign.chevronColor;
    const answerNumberColor = slideDesign.answerNumberColor;
    const subtitleColor = slideDesign.subtitleColor;

    return (
      <>
        {fonts && <Font type="body" font={fonts.body} />}

        <style
          dangerouslySetInnerHTML={{
            __html: `
              /* CSS Variables for customizable colors */
              .slave-container {
                ${chevronColor ? `--chevron-color: ${chevronColor};` : ""}
                ${answerNumberColor ? `--answer-number-color: ${answerNumberColor};` : ""}
                ${subtitleColor ? `--subtitle-color: ${subtitleColor};` : ""}
              }

              /* Color styles */
              .slave-container--default {
                background-color: ${primaryColor};
              }

              .slave-container--modern .topBorder {
                background-color: ${primaryColor};
              }
              .slave-container--modern .question-container__question--number {
                border-color: ${primaryColor};
                color: ${primaryColor};
              }

              .slave-container--modern.slave-container--multiple_choice .question-chevron,
              .slave-container--modern.slave-container--multiple_choice .answer-text.correct-answer {
                color: ${primaryColor};
              }

              .slave-container--title,
              .slave-container--form {
                background-color: ${primaryColor};
              }

              .slave-container--stand .fa.fa-chevron-right {
                color: ${primaryColor};
              }
     
              /* Custom CSS */
              /* Do not move behind background image css */
              ${customCSS}
     
              /* Background image */
              ${
                slideBackgroundImage &&
                `
              .slave-container {
                background-image: url(${slideBackgroundImage.uri});
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                height: 100vh;
              }
              `
              }
                 
            `,
          }}
        />
      </>
    );
  }
}
